import * as tslib_1 from "tslib";
import { RequisitionsQueryFilter } from "./requisitions-query-filter.model";
import { RequisitionsInfiniteScrollContainer } from "./requisitions-infinite-scroll-container";
import { requisitionDisplaySelectedFilter } from "./requisition-display-selected-filter.model";
var RequisitionsPageController = /** @class */ (function () {
    /*@ngInject*/
    function RequisitionsPageController($rootScope, $state, $timeout, $filter, moment, StorageService, requisitionService, jobService, companyService, stateManagementStorageService, genericService, alertsAndNotificationsService, sharedAjsService, REQUISITIONSCONSTANTS, MESSAGECONSTANTS) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.moment = moment;
        this.StorageService = StorageService;
        this.requisitionService = requisitionService;
        this.jobService = jobService;
        this.companyService = companyService;
        this.stateManagementStorageService = stateManagementStorageService;
        this.genericService = genericService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.sharedAjsService = sharedAjsService;
        this.REQUISITIONSCONSTANTS = REQUISITIONSCONSTANTS;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
    }
    RequisitionsPageController.prototype.$onInit = function () {
        this.$stateParams = this.$transition$.params();
        this.userId = this.$rootScope.userDetails.id;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.companyState = this.$rootScope.userDetails.company.companyState;
        this.companyType = this.$rootScope.userDetails.company.companyType;
        this.isCompanyVendor = this.companyService.isCompanyVendor();
        this.isStaffingCompany = this.companyService.isStaffingCompany();
        this.salaryDurationOptions = [];
        this.count = 2;
        this.queryRequisitions = _.debounce(this.queryRequisitions, 500);
        this.showFiltersPanel = false;
        this.isFiltersChanged = false;
        this.isClient = true;
        this.hideSearchByText = false;
        this.showpopup = false;
        this.reqNumFlag = false;
        this.emptySelectedFilter = false;
        this.isRowViewActive = false;
        this.selectedClients = [];
        this.selectedRequisitionTypes = [];
        this.selectedRoles = [];
        this.selectedStatuses = [];
        this.selectedJobTypes = [];
        this.selectedWorkLocations = [];
        this.selectedRecruiters = [];
        this.selectedSortByList = [];
        this.selectedRequisitionNumbers = [];
        this.requisitionNumbersList = [];
        this.sortByList = [];
        this.requisitionsContainer = null;
        this.savedFilters = null;
        this.savedDisplayedRequisitionSelectedFilter = null;
        this.displayRequisitionFilterItemsSelected = [];
        this.searchTerm = '';
        this.requisitions = [];
        var filter = new RequisitionsQueryFilter(this.companyId);
        if (!_.isNull(this.$stateParams.requisitionStatesArray)) {
            filter.requisitionStates = [];
            angular.forEach(this.$stateParams.requisitionStatesArray, function (val, key) {
                filter.requisitionStates.push(angular.uppercase(val));
            });
        }
        this.selectedDateRange = "";
        this.selectedSort = "Please Select";
        if (this.isStaffingCompany) {
            this.isClient = true;
            this.clientOfBuSortValue = "Client";
        }
        else {
            this.isClient = false;
            this.clientOfBuSortValue = "BU";
        }
        this._getDetailsNeededForRequisitionCards();
        this.requisitionsContainer = new RequisitionsInfiniteScrollContainer(this.userId, this.companyId, this.jobService, this.alertsAndNotificationsService, this.isStaffingCompany);
        this.requisitionsContainer.requisitionsQueryFilter = angular.copy(filter);
        // Remove requisition screen on company switch (in super user)
        this._checkAndRemoveIfFilterExistsWithCompanyId();
        var savedFilters = this.stateManagementStorageService.getScreenState("requisitionsScreen-" + this.userId);
        if (savedFilters && filter.requisitionStates.length == 0) {
            this.requisitionsContainer.requisitionsQueryFilter = angular.copy(savedFilters);
            this.savedFilters = angular.copy(savedFilters);
        }
        else {
            this.stateManagementStorageService.setScreenState("requisitionsScreen-" + this.userId, filter);
        }
        // Display Selected Filter
        this.displayRequisitionSelectedFilter = new requisitionDisplaySelectedFilter();
        var savedDisplayedRequisitionSelectedFilter = this.stateManagementStorageService.getScreenState("requisitionsScreen-displayFilter-" + this.userId);
        if (savedDisplayedRequisitionSelectedFilter) {
            if (!_.isNull(this.$stateParams.requisitionStatesArray)) {
                this.stateManagementStorageService.setScreenState("requisitionsScreen-displayFilter-" + this.userId, savedDisplayedRequisitionSelectedFilter);
            }
            this.displayRequisitionSelectedFilter = angular.copy(savedDisplayedRequisitionSelectedFilter);
            // Set Sort By Filter to Null
            this.displayRequisitionSelectedFilter.selectedFilterSort = "";
            this.savedDisplayedRequisitionSelectedFilter = angular.copy(savedDisplayedRequisitionSelectedFilter);
            if (_.isUndefined(this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag)) {
                this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = true;
            }
        }
        else {
            this.stateManagementStorageService.setScreenState("requisitionsScreen-displayFilter-" + this.userId, this.displayRequisitionSelectedFilter);
            this.savedDisplayedRequisitionSelectedFilter = angular.copy(this.displayRequisitionSelectedFilter);
        }
        this.showDisplaySelectedFilterPanel = this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag;
        // If params From Re run scoring
        this.setReRunScoreFilters(filter);
        this._setRequisitionSortByFilter();
        this._getAndSetFilters();
        this._initJquery();
        // this.$timeout(() => {
        //     this.selectedDateRange = '';
        // }, 2000);
        this.currentRequisitionPage = 1;
        this._setRequisitionRowView();
        this.myStyle = "{width: 8%}";
        // If login params exists open documents tab after user login
        if (this.$stateParams.loginParamsObject && this.$stateParams.loginParamsObject.redirect == 'documents') {
            this._openCandidateBookletDocumentsModal();
        }
    };
    RequisitionsPageController.prototype.setReRunScoreFilters = function (filter) {
        if (this.$stateParams.userParamsObject && this.$stateParams.userParamsObject.requisitionNumber) {
            // Reset filters
            this.requisitionsContainer.requisitionsQueryFilter = angular.copy(filter);
            this.requisitionsContainer.requisitionsQueryFilter.requisitionNums = [this.$stateParams.userParamsObject.requisitionNumber];
            this.stateManagementStorageService.setScreenState("requisitionsScreen-" + this.userId, this.requisitionsContainer.requisitionsQueryFilter);
            this.savedFilters = this.requisitionsContainer.requisitionsQueryFilter;
            // Reset Display Filters
            this.displayRequisitionSelectedFilter = new requisitionDisplaySelectedFilter();
            this.displayRequisitionSelectedFilter.requisitionNums = this.requisitionsContainer.requisitionsQueryFilter.requisitionNums;
            this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
            this.stateManagementStorageService.setScreenState("requisitionsScreen-displayFilter-" + this.userId, this.displayRequisitionSelectedFilter);
            this.savedDisplayedRequisitionSelectedFilter = angular.copy(this.displayRequisitionSelectedFilter);
        }
    };
    RequisitionsPageController.prototype._openCandidateBookletDocumentsModal = function () {
        var actionType = 'candidateBooklet';
        var actionLabel = this.$stateParams.loginParamsObject + "'s" + ' Booklet';
        this.sharedAjsService.goToCandidateDocuments(actionType, actionLabel, this.$stateParams.loginParamsObject);
    };
    RequisitionsPageController.prototype._setRequisitionRowView = function () {
        var checkIfRowViewActive = this.stateManagementStorageService.getScreenState("requisitionsScreen-rowView-" + this.userId);
        if (checkIfRowViewActive) {
            this.isRowViewActive = checkIfRowViewActive.isRowViewActive;
            if (this.isRowViewActive) {
                this.requisitionsContainer.getNextPage(this.currentRequisitionPage);
            }
        }
    };
    RequisitionsPageController.prototype.toggleRequisitionRowView = function () {
        this.isRowViewActive = !this.isRowViewActive;
        this.stateManagementStorageService.setScreenState("requisitionsScreen-rowView-" + this.userId, { isRowViewActive: this.isRowViewActive });
        if (this.isRowViewActive) {
            this.requisitionsContainer.getNextPage(this.currentRequisitionPage);
        }
        else {
            this.requisitionsContainer.requisitionsExistFlag = true;
            this.requisitionsContainer.requisitionsQueryFilter.pageNum = 1;
            this.requisitionsContainer.requisitions = [];
            this.requisitionsContainer.disableInfiniteScroll = false;
        }
    };
    RequisitionsPageController.prototype._setRequisitionSortByFilter = function () {
        var _this = this;
        this.requisitionSortByFilters = [
            {
                "column": "clientorbu",
                "columnDisplayName": this.clientOfBuSortValue
            },
            {
                "column": "title",
                "columnDisplayName": "Role"
            },
            {
                "column": "requisitionState",
                "columnDisplayName": "Requisition Status"
            },
            {
                "column": "requisitionNumber",
                "columnDisplayName": "Requisition Number"
            },
            {
                "column": "updatedDate",
                "columnDisplayName": "Updated Date"
            }
        ];
        if (!_.isNull(this.savedFilters) && this.savedFilters.sortColumn !== "" && this.savedFilters.sortDirection !== "") {
            var savedSortColumn = this.savedFilters.sortColumn + " " + this.savedFilters.sortDirection;
            var savedSelectedSort = this.savedFilters.sortDirection.slice(0, 1) + this.savedFilters.sortDirection.slice(1).toLowerCase();
            var savedSortDirection_1 = "";
            this.requisitionSortByFilters.forEach(function (filter) {
                if (filter.column == _this.savedFilters.sortColumn) {
                    savedSortDirection_1 = filter.columnDisplayName;
                }
            });
            this.sortRequisitions(savedSortColumn, savedSortDirection_1, savedSelectedSort);
        }
    };
    RequisitionsPageController.prototype._checkAndRemoveIfFilterExistsWithCompanyId = function () {
        var existingRequisitionScreenState = this.stateManagementStorageService.getScreenState("requisitionsScreen-" + this.userId);
        if (existingRequisitionScreenState) {
            if (existingRequisitionScreenState.companyId !== this.companyId) {
                this.stateManagementStorageService.clearStateScreen("requisitionsScreen-" + this.userId);
                this.stateManagementStorageService.clearStateScreen("requisitionsScreen-displayFilter-" + this.userId);
            }
        }
    };
    RequisitionsPageController.prototype._getAndSetFilters = function () {
        var _this = this;
        this._getClientsOrBus(function () {
            _this._getRoles("all");
            _this.getRequisitionNumbers("all", function () {
                _this._getRecruiters(function () {
                    _this._getRequisitionStatusTypes(function () {
                        _this._getJobTypes(function () {
                            _this._getWorkLocations(function () {
                                _this.savedFilters = null;
                            });
                        });
                    });
                });
            });
        });
        this._setRequisitionTypes();
    };
    RequisitionsPageController.prototype._getDetailsNeededForRequisitionCards = function () {
        this._getRequisitionActivityTypes();
        this._getSalaryDurationOptions();
    };
    RequisitionsPageController.prototype._getClientsOrBus = function (successCallback) {
        var _this = this;
        this.loadingClientsOrBUs = true;
        var requisitionId = null;
        var isFromCreateReq = false;
        this.requisitionService.getAllClientsOrBu(this.$rootScope.userDetails, requisitionId, isFromCreateReq, function (data) {
            _this._setClientsOrBus(data);
            _this.loadingClientsOrBUs = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.loadingClientsOrBUs = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    RequisitionsPageController.prototype._setClientsOrBus = function (clientsOrBus) {
        var _this = this;
        this.fullClientsList = clientsOrBus;
        angular.forEach(this.fullClientsList, function (clientOrBu, key) {
            if (clientOrBu.companyType == 'Corporation') {
                clientOrBu.name = "<span style='padding-right:5px;'>" + clientOrBu.name + "</span><i class='fas fa-share-alt'></i>";
            }
        });
        this.fullClientsListCopy = angular.copy(this.fullClientsList);
        if (this.savedFilters !== null) {
            this.selectedClients = this.fullClientsList.filter(function (clientOrBu) { return _this.savedFilters.clientOrBU.some(function (selectedId) { return clientOrBu.id == selectedId; }); });
            this.selectedClients.forEach(function (clientOrBu) { return clientOrBu.ticked = true; });
        }
        if (this.savedDisplayedRequisitionSelectedFilter.clientOrBU.length !== 0 || this.requisitionsContainer.requisitionsQueryFilter.clientOrBU.length !== 0) {
            this.displayRequisitionSelectedFilter.clientOrBU = [];
            this.displayRequisitionSelectedFilter.clientOrBU = this.selectedClients.map(function (val, index) {
                if (val.companyType === 'Corporation') {
                    return val.shortName;
                }
                else {
                    return val.name;
                }
            });
            this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
        }
    };
    RequisitionsPageController.prototype._getRoles = function (searchReqText) {
        var _this = this;
        this.loadingRoles = true;
        this.fullRolesList = [];
        this.selectedRoles = [];
        if (searchReqText == "" || !angular.isDefined(searchReqText)) {
            searchReqText = "all";
        }
        else {
            this.searchReqText = searchReqText;
        }
        var clientOrBuIds = this.selectedClients.map(function (clientOrBu) { return clientOrBu.id; });
        this.jobService.getRoles(this.userId, this.companyId, this.searchReqText, { clientOrBuIds: clientOrBuIds }, function (data) {
            _this._setRoles(data);
            _this.loadingRoles = false;
        }, function (error) {
            _this.loadingRoles = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    RequisitionsPageController.prototype._setRoles = function (roles) {
        var _this = this;
        angular.forEach(roles, function (val, key) {
            var roleObj = { "name": val };
            if (!_this._containsObject(roleObj, _this.fullRolesList, "name")) {
                if (val !== null)
                    roleObj.selectedDisplayName = _this.$filter('displayOnMultiSelectFilter')(val);
                _this.fullRolesList.push(roleObj);
            }
            _this.fullRolesListCopy = angular.copy(_this.fullRolesList);
        });
        if (this.savedFilters !== null) {
            this.selectedRoles = this.fullRolesList.filter(function (role) { return _this.savedFilters.roleList.some(function (roleName) { return role.name == roleName; }); });
            this.selectedRoles.forEach(function (role) { return role.ticked = true; });
        }
        if (this.savedDisplayedRequisitionSelectedFilter.roleList.length !== 0 || this.requisitionsContainer.requisitionsQueryFilter.roleList.length !== 0) {
            this.displayRequisitionSelectedFilter.roleList = this.selectedRoles.map(function (role) { return role.name; });
            this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
        }
    };
    RequisitionsPageController.prototype._setRequisitionTypes = function () {
        var _this = this;
        this.requisitionTypes = [{ name: 'Shared', value: "SHARED" }];
        if (this.isStaffingCompany) {
            this.requisitionTypes.push({ name: 'External', value: "EXTERNAL" });
        }
        else {
            this.requisitionTypes.push({ name: 'Internal', value: 'INTERNAL' });
        }
        this.requisitionTypesCopy = angular.copy(this.requisitionTypes);
        if (this.savedFilters !== null) {
            this.selectedRequisitionTypes = this.requisitionTypes.filter(function (type) { return _this.savedFilters.requisitionTypes.some(function (typeName) { return typeName == type.value; }); });
            this.selectedRequisitionTypes.forEach(function (type) { return type.ticked = true; });
        }
        if (this.savedDisplayedRequisitionSelectedFilter.requisitionTypes.length !== 0 || this.requisitionsContainer.requisitionsQueryFilter.requisitionTypes.length !== 0) {
            this.displayRequisitionSelectedFilter.requisitionTypes = this.selectedRequisitionTypes.map(function (type) { return type.name; });
            this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
        }
    };
    RequisitionsPageController.prototype._getRequisitionStatusTypes = function (successCallback) {
        var _this = this;
        this.loadingRequisitionStatuses = true;
        this.jobService.getAllStatusTypes(function (data) {
            _this._setRequisitionStatusTypes(data);
            _this.loadingRequisitionStatuses = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.loadingRequisitionStatuses = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    RequisitionsPageController.prototype._setRequisitionStatusTypes = function (statusTypes) {
        var _this = this;
        this.fullStatusList = statusTypes;
        this.fullStatusListCopy = angular.copy(this.fullStatusList);
        if (!_.isNull(this.$stateParams.requisitionStatesArray)) {
            for (var i = 0; i < this.fullStatusList.length; i++) {
                for (var j = 0; j < this.$stateParams.requisitionStatesArray.length; j++) {
                    if (this.fullStatusList[i].name == this.$stateParams.requisitionStatesArray[j]) {
                        this.fullStatusList[i]['ticked'] = true;
                        break;
                    }
                }
            }
        }
        if (this.savedFilters !== null) {
            this.selectedStatuses = this.fullStatusList.filter(function (status) { return _this.savedFilters.requisitionStates.some(function (statusName) { return statusName == status.name.toUpperCase(); }); });
            this.selectedStatuses.forEach(function (status) { return status.ticked = true; });
        }
        if (this.savedDisplayedRequisitionSelectedFilter.requisitionStates.length !== 0 || this.requisitionsContainer.requisitionsQueryFilter.requisitionStates.length !== 0) {
            this.displayRequisitionSelectedFilter.requisitionStates = this.selectedStatuses.map(function (status) { return status.name; });
            this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
        }
    };
    RequisitionsPageController.prototype.getRequisitionNumbers = function (searchReqText, successCallback) {
        var _this = this;
        this.loadingRequisitionNumbers = true;
        this.fullReqNumList = [];
        this.selectedRequisitionNumbers = [];
        if (searchReqText == "" || !angular.isDefined(searchReqText)) {
            searchReqText = "all";
        }
        this.searchReqText = searchReqText;
        var clientOrBuIds = this.selectedClients.map(function (clientOrBu) { return clientOrBu.id; });
        var roleNames = this.selectedRoles.map(function (role) { return role.name; });
        var reqNumberFilter = { clientOrBuIds: clientOrBuIds, roleNames: roleNames };
        this.jobService.searchByReqNum(this.userId, this.companyId, this.searchReqText, reqNumberFilter, function (data) {
            _this._setRequisitionNumbers(data);
            if (searchReqText == "all") {
                _this.fullReqNumListCopy = angular.copy(_this.fullReqNumList);
            }
            _this.loadingRequisitionNumbers = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.loadingRequisitionNumbers = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    RequisitionsPageController.prototype._setRequisitionNumbers = function (requisitionNumbers) {
        var _this = this;
        var modifiedRequisitionNumbers = [];
        for (var i = 0; i < requisitionNumbers.length; i++) {
            var icon = requisitionNumbers[i].sharedRequisition ? '<i class="fas fa-share-alt"></i> ' : '<span class="pl-4"></span>';
            var obj = { name: requisitionNumbers[i].reqNumber, icon: icon };
            // if(!this._containsObject(obj, modifiedRequisitionNumbers, "name")) {
            obj.selectedDisplayName = this.$filter('displayOnMultiSelectFilter')(obj.name);
            modifiedRequisitionNumbers.push(obj);
            // }
        }
        for (var i = 0; i < modifiedRequisitionNumbers.length; i++) {
            for (var j = 0; j < this.selectedRequisitionNumbers.length; j++) {
                if (modifiedRequisitionNumbers[i].name == this.selectedRequisitionNumbers[j].name) {
                    modifiedRequisitionNumbers[i]['ticked'] = true;
                    break;
                }
            }
        }
        this.fullReqNumList = angular.copy(modifiedRequisitionNumbers);
        if (this.savedFilters !== null || (this.$stateParams.userParamsObject && this.$stateParams.userParamsObject.requisitionNumber)) {
            if (this.$stateParams.userParamsObject) {
                this.selectedRequisitionNumbers = this.fullReqNumList.filter(function (reqNumber) { return _this.$stateParams.userParamsObject.requisitionNumber == reqNumber.name; });
            }
            else {
                this.selectedRequisitionNumbers = this.fullReqNumList.filter(function (reqNumber) { return _this.savedFilters.requisitionNums.some(function (num) { return num == reqNumber.name; }); });
            }
            this.selectedRequisitionNumbers.forEach(function (num) { return num.ticked = true; });
        }
        if (this.savedDisplayedRequisitionSelectedFilter.requisitionNums.length !== 0 || this.requisitionsContainer.requisitionsQueryFilter.requisitionNums.length !== 0 || (this.$stateParams.userParamsObject && this.$stateParams.userParamsObject.requisitionNumber)) {
            this.displayRequisitionSelectedFilter.requisitionNums = this.selectedRequisitionNumbers.map(function (req) { return req.name; });
            this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
        }
    };
    RequisitionsPageController.prototype._getRecruiters = function (successCallback) {
        var _this = this;
        this.fullRecruitersList = [];
        this.selectedRecruiters = [];
        var clientOrBUId = null;
        var requisitionId = null;
        this.loadingRecruiters = true;
        var clientOrBuIds = this.selectedClients.map(function (clientOrBu) { return clientOrBu.id; });
        var requisitionNumbers = [];
        if (this.selectedClients.length > 0) {
            requisitionNumbers = this.fullReqNumList.map(function (reqNum) { return reqNum.name; });
        }
        var isUploadOrEditReq = false;
        this.jobService.getAllRecruiters(this.$rootScope.userDetails, this.$rootScope.userDetails.company, clientOrBUId, requisitionId, clientOrBuIds, requisitionNumbers, isUploadOrEditReq, function (data) {
            var newRecruiterArray = [];
            var recruiters = data.recruiters;
            var hiringManagers = data.hiringManagers;
            var pocs = data.pocs;
            for (var i = 0; i < recruiters.length; i++) {
                var name;
                if (recruiters[i].lastName !== null) {
                    name = recruiters[i].firstName + " " + recruiters[i].lastName;
                }
                else {
                    name = recruiters[i].firstName;
                }
                var recObj = { "name": name, "id": recruiters[i].userId };
                if (!_this._containsObject(recObj, newRecruiterArray, "name")) {
                    recObj.selectedDisplayName = name.length > 25 ? name.substring(0, 30) + "..." : name;
                    recObj.selectedDisplayName = recObj.selectedDisplayName + " <sup>R</sup>";
                    newRecruiterArray.push(recObj);
                }
            }
            hiringManagers.forEach(function (manager) {
                var name;
                if (manager.lastName !== null) {
                    name = manager.firstName + " " + manager.lastName;
                }
                else {
                    name = manager.firstName;
                }
                var recObj = { "name": name, "id": manager.userId };
                if (!_this._containsObject(recObj, newRecruiterArray, "name")) {
                    recObj.selectedDisplayName = name.length > 25 ? name.substring(0, 30) + "..." : name;
                    recObj.selectedDisplayName = recObj.selectedDisplayName + " <sup>H</sup>";
                    newRecruiterArray.push(recObj);
                }
            });
            pocs.forEach(function (poc) {
                if (poc) {
                    var name_1;
                    if (poc.lastName !== null) {
                        name_1 = poc.firstName + " " + poc.lastName;
                    }
                    else {
                        name_1 = poc.firstName;
                    }
                    var recObj = { "name": name_1, "id": poc.userId };
                    if (!_this._containsObject(recObj, newRecruiterArray, "name")) {
                        recObj.selectedDisplayName = name_1.length > 25 ? name_1.substring(0, 30) + "..." : name_1;
                        recObj.selectedDisplayName = recObj.selectedDisplayName + " <sup>POC</sup>";
                        newRecruiterArray.push(recObj);
                    }
                }
            });
            _this.fullRecruitersList = angular.copy(newRecruiterArray);
            _this.fullRecruitersListCopy = angular.copy(_this.fullRecruitersList);
            if (_this.savedFilters !== null) {
                _this.selectedRecruiters = _this.fullRecruitersList.filter(function (recruiter) { return _this.savedFilters.recruiters.some(function (recruiterId) { return recruiterId == recruiter.id; }); });
                _this.selectedRecruiters.forEach(function (recruiter) { return recruiter.ticked = true; });
            }
            if (_this.savedDisplayedRequisitionSelectedFilter.recruiters.length !== 0 || _this.requisitionsContainer.requisitionsQueryFilter.recruiters.length !== 0) {
                _this.displayRequisitionSelectedFilter.recruiters = _this.selectedRecruiters.map(function (recruiter) { return recruiter.name; });
                _this.setRequisitionDisplayedFilterItemSelected(_this.displayRequisitionSelectedFilter);
            }
            _this.loadingRecruiters = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.loadingRecruiters = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    RequisitionsPageController.prototype._getJobTypes = function (successCallback) {
        var _this = this;
        this.loadingJobTypes = true;
        this.jobService.getAllJobTypes(function (data) {
            _this.jobTypeList = data;
            _this.jobTypeListCopy = angular.copy(_this.jobTypeList);
            if (_this.savedFilters !== null) {
                _this.selectedJobTypes = _this.jobTypeList.filter(function (jobType) { return _this.savedFilters.jobTypes.some(function (jobTypeName) { return jobTypeName == jobType.value; }); });
                _this.selectedJobTypes.forEach(function (jobType) { return jobType.ticked = true; });
            }
            if (_this.savedDisplayedRequisitionSelectedFilter.jobTypes.length !== 0 || _this.requisitionsContainer.requisitionsQueryFilter.jobTypes.length !== 0) {
                _this.displayRequisitionSelectedFilter.jobTypes = _this.selectedJobTypes.map(function (type) { return type.name; });
                _this.setRequisitionDisplayedFilterItemSelected(_this.displayRequisitionSelectedFilter);
            }
            _this.loadingJobTypes = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.loadingJobTypes = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    RequisitionsPageController.prototype._getWorkLocations = function (successCallback) {
        var _this = this;
        this.loadingWorkLocations = true;
        this.jobService.getWorkLocations(function (data) {
            _this.workLocationList = data;
            _this.workLocationList = _this.workLocationList.filter(function (location) { return location.id != 'NO_WORK_LOCATION'; });
            _this.workLocationListCopy = angular.copy(_this.workLocationList);
            if (_this.savedFilters !== null && _this.savedFilters.workLocationIds) {
                _this.selectedWorkLocations = _this.workLocationList.filter(function (workLocation) { return _this.savedFilters.workLocationIds.some(function (id) { return id === workLocation.id; }); });
                _this.selectedWorkLocations.forEach(function (workLocation) { return workLocation.ticked = true; });
            }
            if (_this.savedDisplayedRequisitionSelectedFilter.workLocationIds.length !== 0 || _this.requisitionsContainer.requisitionsQueryFilter.workLocationIds.length !== 0) {
                _this.displayRequisitionSelectedFilter.workLocationIds = _this.selectedWorkLocations.map(function (workLocation) { return workLocation.name; });
                _this.setRequisitionDisplayedFilterItemSelected(_this.displayRequisitionSelectedFilter);
            }
            _this.loadingWorkLocations = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.loadingWorkLocations = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    RequisitionsPageController.prototype._containsObject = function (obj, list, key) {
        for (var index in list) {
            var currentObject = list[index];
            for (var prop in currentObject) {
                if (prop === key && currentObject.hasOwnProperty(prop)
                    && currentObject[prop] === obj[prop]) {
                    return true;
                }
            }
        }
        return false;
    };
    RequisitionsPageController.prototype._getRequisitionActivityTypes = function () {
        var _this = this;
        this.jobService.getActivityTypes(function (data) {
            _this.fullActivityList = data;
            _this.activityMap = [];
            angular.forEach(data, function (val, key) {
                _this.activityMap[val.value] = val.name;
            });
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    RequisitionsPageController.prototype._getSalaryDurationOptions = function (successCallback) {
        var _this = this;
        this.jobService.getSalaryDurationOptions(function (data) {
            _this.salaryDurationOptions = data;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            //do nothing
        });
    };
    RequisitionsPageController.prototype.queryRequisitions = function () {
        var _this = this;
        this.requisitionsContainer.loadingSearchButton = true;
        // clear any existing query requests
        // check for an existing promise and see if it has not been fulfilled yet. If it has not been fulfilled yet, cancel the promise.
        // if(!(_.isNull(this.requisitionsContainer.currentPromise) || this.requisitionsContainer.currentPromise === undefined) && this.requisitionsContainer.currentPromise.$$state.status == 0) {
        if (!(_.isNull(this.requisitionsContainer.currentPromise) || this.requisitionsContainer.currentPromise === undefined)) {
            this.genericService.cancelRequest(this.requisitionsContainer.currentPromise);
        }
        // reset the initial value of requisitions exist flag to true
        this.requisitionsContainer.requisitionsExistFlag = true;
        // reset the page number to 1 as this is a new query
        this.requisitionsContainer.requisitionsQueryFilter.pageNum = 1;
        this.currentRequisitionPage = 1;
        // clear the existing requisitions
        this.requisitionsContainer.requisitions = [];
        this.requisitionsContainer.disableInfiniteScroll = false;
        // Hide Display Filter
        if (this.displayRequisitionFilterItemsSelected.length === 0) {
            this.displayFilterFlag = false;
            this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = true;
        }
        // wait for the cancel promise to be fulfilled, if it was called.
        this.$timeout(function () {
            _this.stateManagementStorageService.setScreenState("requisitionsScreen-" + _this.userId, _this.requisitionsContainer.requisitionsQueryFilter);
            // Display Selected Filter
            _this.stateManagementStorageService.setScreenState("requisitionsScreen-displayFilter-" + _this.userId, _this.displayRequisitionSelectedFilter);
            _this.isFiltersChanged = false;
            if (_this.isRowViewActive) {
                _this.requisitionsContainer.getNextPage(_this.currentRequisitionPage);
            }
            else {
                _this.requisitionsContainer.getNext();
            }
        }, 200);
    };
    RequisitionsPageController.prototype._setRecruiters = function (recruiters) {
        var newRecruiterArray = [];
        if (recruiters.length == 0) {
            this.selectedRecruiters = [];
            this.requisitionsContainer.requisitionsQueryFilter.recruiters = [];
        }
        var $selectedRecruiters = angular.copy(this.selectedRecruiters);
        for (var i = 0; i < recruiters.length; i++) {
            var name;
            if (recruiters[i].lastname !== null) {
                name = recruiters[i].firstname + " " + recruiters[i].lastname;
            }
            else {
                name = recruiters[i].firstname;
            }
            var recObj = { "name": name, "id": recruiters[i].id };
            if (!this._containsObject(recObj, newRecruiterArray, "name")) {
                recObj.selectedDisplayName = this.$filter('displayOnMultiSelectFilter')(name);
                newRecruiterArray.push(recObj);
            }
        }
        for (var i = 0; i < newRecruiterArray.length; i++) {
            for (var j = 0; j < $selectedRecruiters.length; j++) {
                if (newRecruiterArray[i].id == $selectedRecruiters[j].id) {
                    newRecruiterArray[i]['ticked'] = true;
                    break;
                }
            }
        }
        this.fullRecruitersList = angular.copy(newRecruiterArray);
    };
    RequisitionsPageController.prototype._setClients = function (clients) {
        var newClientArray = [];
        if (clients.length == 0) {
            this.selectedClients = [];
            this.requisitionsContainer.requisitionsQueryFilter.clientOrBU = [];
        }
        this.selectedClients = angular.copy(this.selectedClients);
        for (var i = 0; i < clients.length; i++) {
            if (angular.isDefined(clients[i]) && clients[i] != null && angular.isDefined(clients[i].id)) {
                var recObj = { "name": clients[i].name, "id": clients[i].id };
                if (!this._containsObject(recObj, newClientArray, "name")) {
                    newClientArray.push(recObj);
                }
            }
        }
        for (var i = 0; i < newClientArray.length; i++) {
            for (var j = 0; j < $selectedClients.length; j++) {
                if (newClientArray[i].id == $selectedClients[j].id) {
                    newClientArray[i]['ticked'] = true;
                    break;
                }
            }
        }
        this.fullClientsList = angular.copy(newClientArray);
    };
    RequisitionsPageController.prototype.toggleSearchByText = function () {
        this.hideSearchByText = !this.hideSearchByText;
    };
    RequisitionsPageController.prototype.onClientClick = function () {
        var _this = this;
        this.isFiltersChanged = true;
        this._getRoles("all");
        this.getRequisitionNumbers("all", function () {
            _this._getRecruiters(function () {
                _this.requisitionsContainer.requisitionsQueryFilter.clientOrBU = _this.selectedClients.map(function (clientOrBu) { return clientOrBu.id; });
                _this.requisitionsContainer.requisitionsQueryFilter.roleList = [];
                _this.requisitionsContainer.requisitionsQueryFilter.requisitionNums = [];
                _this.requisitionsContainer.requisitionsQueryFilter.recruiters = [];
                _this.displayRequisitionSelectedFilter.clientOrBU = _this.selectedClients.map(function (val, index) {
                    if (val.companyType === 'Corporation') {
                        return val.shortName;
                    }
                    else {
                        return val.name;
                    }
                });
                _this.displayRequisitionSelectedFilter.roleList = [];
                _this.displayRequisitionSelectedFilter.recruiters = [];
                _this.displayRequisitionSelectedFilter.requisitionNums = [];
                _this.setRequisitionDisplayedFilterItemSelected(_this.displayRequisitionSelectedFilter);
            });
        });
    };
    RequisitionsPageController.prototype.onRoleClick = function () {
        var _this = this;
        this.isFiltersChanged = true;
        this.getRequisitionNumbers("all", function () {
            _this._getRecruiters(function () {
                _this.requisitionsContainer.requisitionsQueryFilter.roleList = _this.selectedRoles.map(function (role) { return role.name; });
                _this.requisitionsContainer.requisitionsQueryFilter.requisitionNums = [];
                _this.requisitionsContainer.requisitionsQueryFilter.recruiters = [];
                _this.displayRequisitionSelectedFilter.roleList = _this.requisitionsContainer.requisitionsQueryFilter.roleList;
                _this.displayRequisitionSelectedFilter.recruiters = [];
                _this.displayRequisitionSelectedFilter.requisitionNums = [];
                _this.setRequisitionDisplayedFilterItemSelected(_this.displayRequisitionSelectedFilter);
            });
        });
    };
    RequisitionsPageController.prototype.onRequisitionTypeClick = function () {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter.requisitionTypes = this.selectedRequisitionTypes.map(function (type) { return type.value; });
        this.displayRequisitionSelectedFilter.requisitionTypes = [];
        this.displayRequisitionSelectedFilter.requisitionTypes = this.selectedRequisitionTypes.map(function (type) { return type.name; });
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    };
    RequisitionsPageController.prototype.onRequisitionStatusClick = function () {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter.requisitionStates = this.selectedStatuses.map(function (status) { return angular.uppercase(status.name); });
        this.displayRequisitionSelectedFilter.requisitionStates = this.selectedStatuses.map(function (status) { return status.name; });
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    };
    RequisitionsPageController.prototype.onRequisitionNumberClick = function () {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter.requisitionNums = this.selectedRequisitionNumbers.map(function (req) { return req.name; });
        this.displayRequisitionSelectedFilter.requisitionNums = this.requisitionsContainer.requisitionsQueryFilter.requisitionNums;
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    };
    RequisitionsPageController.prototype.onRecruiterClick = function () {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter.recruiters = this.selectedRecruiters.map(function (recruiter) { return recruiter.id; });
        this.displayRequisitionSelectedFilter.recruiters = this.selectedRecruiters.map(function (recruiter) { return recruiter.name; });
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    };
    RequisitionsPageController.prototype.onJobTypeClick = function () {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter.jobTypes = this.selectedJobTypes.map(function (type) { return type.value; });
        this.displayRequisitionSelectedFilter.jobTypes = this.selectedJobTypes.map(function (type) { return type.name; });
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    };
    RequisitionsPageController.prototype.onWorkLocationClick = function () {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter.workLocationIds = this.selectedWorkLocations.map(function (workLocation) { return workLocation.id; });
        this.displayRequisitionSelectedFilter.workLocationIds = this.selectedWorkLocations.map(function (workLocation) { return workLocation.name; });
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    };
    RequisitionsPageController.prototype._setShowDisplayFilterIcon = function (boolean) {
        var savedDisplayedRequisitionSelectedFilter = this.stateManagementStorageService.getScreenState("requisitionsScreen-displayFilter-" + this.userId);
        savedDisplayedRequisitionSelectedFilter.showDisplayFilterIconFlag = boolean;
        this.stateManagementStorageService.setScreenState("requisitionsScreen-displayFilter-" + this.userId, savedDisplayedRequisitionSelectedFilter);
        if (this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag !== boolean) {
            this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = boolean;
        }
    };
    RequisitionsPageController.prototype.displaySelectedFilterToggle = function () {
        this.showDisplaySelectedFilterPanel = true;
        if (this.displayFilterFlag) {
            $("#display-selected-filter-panel").animate({
                height: 'toggle'
            });
            this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = !this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag;
        }
        // Set Display Filter Collapse and Expand Panel
        this._setShowDisplayFilterIcon(this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag);
    };
    RequisitionsPageController.prototype.isFilterValueArray = function (value) {
        if (Array.isArray(value)) {
            return true;
        }
        else {
            return false;
        }
    };
    RequisitionsPageController.prototype.addToDisplayFilters = function (event) {
        switch (event) {
            case 'search':
                this.displayRequisitionSelectedFilter.searchString = this.requisitionsContainer.requisitionsQueryFilter.searchText;
                this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
                break;
            default:
                break;
        }
    };
    RequisitionsPageController.prototype._setObjectVariableName = function (currentObject) {
        var selectedFilterVariableNameObj = {
            clientOrBU: "Belongs To", roleList: "Role", requisitionTypes: "Requisition Type",
            requisitionStates: "Requisition Status", requisitionNums: "Requisition Number", recruiters: "Recruiter/Hiring Manager",
            jobTypes: "Job Type", workLocationIds: "Work Location", selectedFilterSort: "Sort By", searchString: "Search"
        };
        for (var key in selectedFilterVariableNameObj) {
            if (selectedFilterVariableNameObj.hasOwnProperty(key)) {
                var obj = selectedFilterVariableNameObj[key];
                if (key == currentObject.variable) {
                    this.displaySelectedFilterObj.variable = obj;
                }
            }
        }
    };
    RequisitionsPageController.prototype.setRequisitionDisplayedFilterItemSelected = function (itemsSelected) {
        var _this = this;
        this.emptySelectedFilter = false;
        for (var key in itemsSelected) {
            if (itemsSelected.hasOwnProperty(key)) {
                var obj = itemsSelected[key];
                if (obj.length > 0) {
                    this.displayFilterFlag = true;
                    this.displaySelectedFilterObj = {};
                    if (this.displayRequisitionFilterItemsSelected.length !== 0) {
                        this.displayRequisitionFilterItemsSelected.forEach(function (filterItem) {
                            if (filterItem.filter == key) {
                                if (filterItem.setSelectedFilterLimit == 5) {
                                    _this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                                }
                                else {
                                    _this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: obj.length, expandSelectedFilter: filterItem.expandSelectedFilter };
                                }
                            }
                        });
                    }
                    if (this.displayRequisitionFilterItemsSelected.length == 0 || Object.keys(this.displaySelectedFilterObj).length == 0) {
                        this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                    }
                    this._setObjectVariableName(this.displaySelectedFilterObj);
                    if (this.displayRequisitionFilterItemsSelected.length > 0) {
                        this.displayRequisitionFilterItemsSelected = this.displayRequisitionFilterItemsSelected.filter(function (item) { return item.variable !== _this.displaySelectedFilterObj.variable; });
                    }
                    this.displayRequisitionFilterItemsSelected.push(this.displaySelectedFilterObj);
                }
                else {
                    if (this.displayRequisitionFilterItemsSelected.length > 0) {
                        this.displayRequisitionFilterItemsSelected = this.displayRequisitionFilterItemsSelected.filter(function (item) { return item.filter !== key; });
                    }
                }
            }
        }
        if (this.displayRequisitionFilterItemsSelected.length === 0) {
            if (!this.requisitionsContainer.isFilterOn) {
                this.displayFilterFlag = false;
                this._setShowDisplayFilterIcon(true);
            }
            else {
                this.emptySelectedFilter = true;
            }
        }
    };
    RequisitionsPageController.prototype._setOpenGlobalFilter = function () {
        if (!this.showFiltersPanel) {
            $("#search-panel").animate({
                height: 'toggle'
            });
            this.showFiltersPanel = true;
        }
    };
    RequisitionsPageController.prototype._deleteSelectedItem = function (currentObject, deletedItem) {
        var _this = this;
        switch (currentObject.variable) {
            case 'searchString':
                this.requisitionsContainer.requisitionsQueryFilter.searchText = '';
                this.displayRequisitionSelectedFilter.searchString = '';
                this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
                break;
            case 'clientOrBU':
                this.fullClientsList.forEach(function (client, index) {
                    if (client.name === deletedItem) {
                        client.ticked = false;
                        _this.selectedClients = _this.selectedClients.filter(function (item) { return item.name !== deletedItem; });
                    }
                    else if (client.shortName === deletedItem) {
                        client.ticked = false;
                        _this.selectedClients = _this.selectedClients.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onClientClick();
                break;
            case 'roleList':
                this.fullRolesList.forEach(function (role, index) {
                    if (role.name === deletedItem) {
                        role.ticked = false;
                        _this.selectedRoles = _this.selectedRoles.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onRoleClick();
                break;
            case 'requisitionTypes':
                this.requisitionTypes.forEach(function (reqType, index) {
                    if (reqType.name === deletedItem) {
                        reqType.ticked = false;
                        _this.selectedRequisitionTypes = _this.selectedRequisitionTypes.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onRequisitionTypeClick();
                break;
            case 'requisitionStates':
                this.fullStatusList.forEach(function (reqStatus, index) {
                    if (reqStatus.name === deletedItem) {
                        reqStatus.ticked = false;
                        _this.selectedStatuses = _this.selectedStatuses.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onRequisitionStatusClick();
                break;
            case 'requisitionNums':
                this.fullReqNumList.forEach(function (reqNum, index) {
                    if (reqNum.name === deletedItem) {
                        reqNum.ticked = false;
                        _this.selectedRequisitionNumbers = _this.selectedRequisitionNumbers.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onRequisitionNumberClick();
                break;
            case 'recruiters':
                this.fullRecruitersList.forEach(function (recruiter, index) {
                    if (recruiter.name === deletedItem) {
                        recruiter.ticked = false;
                        _this.selectedRecruiters = _this.selectedRecruiters.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onRecruiterClick();
                break;
            case 'jobTypes':
                this.jobTypeList.forEach(function (jobType, index) {
                    if (jobType.name === deletedItem) {
                        jobType.ticked = false;
                        _this.selectedJobTypes = _this.selectedJobTypes.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onJobTypeClick();
                break;
            case 'workLocationIds':
                this.workLocationList.forEach(function (location, index) {
                    if (location.name === deletedItem) {
                        location.ticked = false;
                        _this.selectedWorkLocations = _this.selectedWorkLocations.filter(function (item) { return item.name !== deletedItem; });
                    }
                });
                this.onWorkLocationClick();
                break;
            case 'selectedFilterSort':
                this.sortRequisitions('', 'Please Select', '');
                break;
            default:
                break;
        }
    };
    RequisitionsPageController.prototype.deleteSelectedFilterItem = function (deletedItem) {
        this._setOpenGlobalFilter();
        for (var key in this.displayRequisitionSelectedFilter) {
            if (this.displayRequisitionSelectedFilter.hasOwnProperty(key)) {
                var obj = this.displayRequisitionSelectedFilter[key];
                if (Array.isArray(obj)) {
                    if (obj.includes(deletedItem)) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
                    }
                }
                else {
                    if (obj == deletedItem) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
                    }
                }
            }
        }
    };
    RequisitionsPageController.prototype.setCandidate = function (candidate, candidateFlag) {
        this.requisitionSPOC.candidateId = candidate[0].id;
        if (candidateFlag) {
            this.requisitionSPOC.openingNumber = candidate[0].requisitionOpeningNumber;
        }
    };
    //            this.searchRequisitions =  (requisition) {
    //                return (angular.lowercase(requisition.companyName).indexOf(angular.lowercase(this.searchTerm) || '') !== -1 ||
    //                    angular.lowercase(requisition.requisitionRole).indexOf(angular.lowercase(this.searchTerm) || '') !== -1);
    //            };
    RequisitionsPageController.prototype.deleteRequisition = function (requisition) {
        if (this.isRowViewActive) {
            var rowViewRequisitionIndex = _.findIndex(this.requisitionsContainer.requisitionsPerPage, { 'requisitionNumber': requisition.requisitionNumber });
            this.requisitionsContainer.requisitionsPerPage.splice(rowViewRequisitionIndex, 1);
        }
        else {
            var requisitionIndex = _.findIndex(this.requisitionsContainer.requisitions, { 'requisitionNumber': requisition.requisitionNumber });
            this.requisitionsContainer.requisitions.splice(requisitionIndex, 1);
        }
        this.requisitionsContainer.requisitionCount = this.requisitionsContainer.requisitionCount - 1;
    };
    RequisitionsPageController.prototype.copyRequisition = function () {
        this.$state.reload();
    };
    RequisitionsPageController.prototype.selectRemoveAll = function (label, type) {
        this._setFiltersAndFetchJobs(label, type);
    };
    RequisitionsPageController.prototype._setFiltersAndFetchJobs = function (label, type) {
        if (type == 'selectAll') {
            if (label === this.MESSAGECONSTANTS.LABLES.CLIENT || label === this.MESSAGECONSTANTS.LABLES.BU) {
                this.selectedClients = tslib_1.__spread(this.fullClientsList);
                this.onClientClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.USER_MANAGEMENT.ROLE) {
                this.selectedRoles = tslib_1.__spread(this.fullRolesList);
                this.onRoleClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.REQUISITION_STATUS) {
                this.selectedStatuses = tslib_1.__spread(this.fullStatusList);
                this.onRequisitionStatusClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.RECRUITER) {
                this.selectedRecruiters = tslib_1.__spread(this.fullRecruitersList);
                this.onRecruiterClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.REQ_NUMBER) {
                this.selectedRequisitionNumbers = tslib_1.__spread(this.fullReqNumList);
                this.onRequisitionNumberClick();
            }
            else if (label === 'requisitionType') {
                this.selectedRequisitionTypes = tslib_1.__spread(this.requisitionTypes);
                this.onRequisitionTypeClick();
            }
            else if (label == 'Job Type') {
                this.selectedJobTypes = tslib_1.__spread(this.jobTypeList);
                this.onJobTypeClick();
            }
            else if (label == 'Work Location') {
                this.selectedWorkLocations = tslib_1.__spread(this.workLocationList);
                this.onWorkLocationClick();
            }
        }
        else {
            if (label === this.MESSAGECONSTANTS.LABLES.CLIENT || label === this.MESSAGECONSTANTS.LABLES.BU) {
                this.fullClientsList.forEach(function (clientOrBU) { return clientOrBU.ticked = false; });
                this.selectedClients = [];
                this.onClientClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.USER_MANAGEMENT.ROLE) {
                this.fullRolesList.map(function (role) { return role.ticked = false; });
                this.selectedRoles = [];
                this.onRoleClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.REQUISITION_STATUS) {
                this.fullStatusList.map(function (status) { return status.ticked = false; });
                this.selectedStatuses = [];
                this.onRequisitionStatusClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.RECRUITER) {
                this.fullRecruitersList.forEach(function (recruiter) { return recruiter.ticked = false; });
                this.selectedRecruiters = [];
                this.onRecruiterClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.REQ_NUMBER) {
                this.fullReqNumList.map(function (num) { return num.ticked = false; });
                this.selectedRequisitionNumbers = [];
                this.onRequisitionNumberClick();
            }
            else if (label === 'requisitionType') {
                this.requisitionTypes.forEach(function (type) { return type.ticked = false; });
                this.selectedRequisitionTypes = [];
                this.onRequisitionTypeClick();
            }
            else if (label == 'Job Type') {
                this.jobTypeList.map(function (type) { return type.ticked = false; });
                this.selectedJobTypes = [];
                this.onJobTypeClick();
            }
            else if (label == 'Work Location') {
                this.workLocationList.map(function (workLocation) { return workLocation.ticked = false; });
                this.selectedWorkLocations = [];
                this.onWorkLocationClick();
            }
        }
    };
    RequisitionsPageController.prototype.sortRequisitions = function (sortColumn, selectedSort, selectedSortDir) {
        this.isFiltersChanged = true;
        this.selectedSort = selectedSort;
        this.selectedSortDir = selectedSortDir;
        this.requisitionsContainer.requisitionsQueryFilter.sortColumn = "";
        this.requisitionsContainer.requisitionsQueryFilter.sortDirection = "";
        if (angular.isDefined(sortColumn) && sortColumn != "") {
            var array = sortColumn.split(" ");
            this.requisitionsContainer.requisitionsQueryFilter.sortColumn = array[0];
            this.requisitionsContainer.requisitionsQueryFilter.sortDirection = array[1];
        }
        this.displayRequisitionSelectedFilter.selectedFilterSort = "";
        if (selectedSort != "Please Select") {
            this.displayRequisitionSelectedFilter.selectedFilterSort = selectedSort + " " + "(" + selectedSortDir + ")";
        }
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    };
    RequisitionsPageController.prototype.sortByDate = function (daterange) {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter.fromDate = "";
        this.requisitionsContainer.requisitionsQueryFilter.toDate = "";
        this.selectedDateRangeCopy = angular.copy(this.selectedDateRange);
        if (angular.isDefined(this.selectedDateRangeCopy) && this.selectedDateRangeCopy !== "") {
            var array = this.selectedDateRangeCopy.split("-");
            this.requisitionsContainer.requisitionsQueryFilter.fromDate = array[0];
            this.requisitionsContainer.requisitionsQueryFilter.toDate = array[1];
        }
        else {
            this.selectedDateRange = "";
        }
    };
    RequisitionsPageController.prototype.resetFilterData = function () {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter = angular.copy(new RequisitionsQueryFilter(this.companyId));
        this.selectedSort = "Please Select";
        this.fullClientsList = angular.copy(this.fullClientsListCopy);
        this.fullRecruitersList = angular.copy(this.fullRecruitersListCopy);
        this.fullRolesList = angular.copy(this.fullRolesListCopy);
        this.fullStatusList = angular.copy(this.fullStatusListCopy);
        this.jobTypeList = angular.copy(this.jobTypeListCopy);
        this.workLocationList = angular.copy(this.workLocationListCopy);
        this.fullReqNumList = angular.copy(this.fullReqNumListCopy);
        this.requisitionTypes = angular.copy(this.requisitionTypes);
        angular.forEach(this.fullClientsList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.fullRecruitersList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.fullRolesList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.fullStatusList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.jobTypeList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.workLocationList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.fullReqNumList, function (val, key) {
            val.ticked = false;
        });
        angular.forEach(this.requisitionTypes, function (val, key) {
            val.ticked = false;
        });
        this.displayRequisitionSelectedFilter = new requisitionDisplaySelectedFilter();
        var savedDisplayedRequisitionSelectedFilter = this.stateManagementStorageService.getScreenState("requisitionsScreen-displayFilter-" + this.userId);
        this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = savedDisplayedRequisitionSelectedFilter.showDisplayFilterIconFlag;
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    };
    RequisitionsPageController.prototype.uploadRequisition = function () {
        var _this = this;
        if (this.isStaffingCompany && (!this.fullClientsList || this.fullClientsList.length == 0)) {
            var message = "Please setup atleast one client in 'Manage Client' before creating a Requisition.";
            this.alertsAndNotificationsService.showCustomConfirm("Add Client", "Cancel", "No Clients", message, "warning", 'medium', function () {
                _this.$state.go('missioncontrol.clientsOrBus', { reload: true });
            }, function () { });
        }
        else {
            this.$state.go('missioncontrol.uploadreq', { jobState: 'Draft' });
        }
    };
    RequisitionsPageController.prototype._initJquery = function () {
        // $('input[name="daterange"]').daterangepicker({
        //     locale: {
        //         cancelLabel: 'Clear'
        //     },
        //     ranges: {
        //         'Today': [this.moment(), this.moment()],
        //         'Yesterday': [this.moment().subtract(1, 'days'), this.moment().subtract(1, 'days')],
        //         'This Week': [this.moment().startOf('week'), this.moment().endOf('week')],
        //         'Last Week': [this.moment().subtract(1, 'week').startOf('week'), this.moment().subtract(1, 'week').endOf('week')],
        //         'This Month': [this.moment().startOf('month'), this.moment().endOf('month')],
        //         'Last Month': [this.moment().subtract(1, 'month').startOf('month'), this.moment().subtract(1, 'month').endOf('month')],
        //         'This Quarter': [this.moment().startOf('quarter'), this.moment().endOf('quarter')],
        //         'Last Quarter': [this.moment().subtract(1, 'quarter').startOf('quarter'), this.moment().subtract(1, 'quarter').endOf('quarter')],
        //         'Past 6 Weeks': [this.moment().subtract(5, 'week').startOf('week'), this.moment().endOf('week')],
        //         'Past 6 Months': [this.moment().subtract(5, 'month').startOf('month'), this.moment().endOf('month')],
        //         'Past 6 Quarter': [this.moment().subtract(5, 'quarter').startOf('quarter'), this.moment().endOf('quarter')],
        //     }
        // });
        var _this = this;
        // $('input[name="daterange"]').on('cancel.daterangepicker', (ev, picker) => {
        //     $(this).val("");
        //     this.requisitionsContainer.requisitionsQueryFilter.fromDate = "";
        //     this.requisitionsContainer.requisitionsQueryFilter.toDate = "";
        //     this.filterJobs(() => {
        //     });
        // });
        //Implementaion of filters
        $(document).ready(function () {
            $("#search-panel").hide();
            $(document).off("click", "#open-filter").on("click", "#open-filter", function () {
                $("#search-panel").animate({
                    height: 'toggle'
                });
                _this.showFiltersPanel = !_this.showFiltersPanel;
            });
        });
        // $('html').on('mouseup', (e) => {
        //     if(!$(e.target).closest('.popover').length) {
        //         $('.popover').each(() => {
        //             $(this.previousSibling).popover('hide');
        //         });
        //     }
        // });
    };
    RequisitionsPageController.prototype.onGlobalFilterChange = function (event) {
        this.isFiltersChanged = true;
        if (!this.showFiltersPanel) {
            $("#search-panel").animate({
                height: 'toggle'
            });
            this.showFiltersPanel = true;
        }
        if (this._onEnterKeyPress(event)) {
            this.queryRequisitions();
        }
    };
    RequisitionsPageController.prototype._onEnterKeyPress = function (event) {
        return event && event.keyCode == 13;
    };
    return RequisitionsPageController;
}());
export { RequisitionsPageController };
RequisitionsPageController.$inject = ['$rootScope', '$state', '$timeout', '$filter', 'moment', 'StorageService', 'requisitionService', 'jobService', 'companyService', 'stateManagementStorageService', 'genericService', 'alertsAndNotificationsService', 'sharedAjsService', 'REQUISITIONSCONSTANTS', 'MESSAGECONSTANTS'];
// import * as TEMPLATE from './requisitions-page.html';
import * as TEMPLATE from 'raw-loader!./requisitions-page.html';
export var RequisitionsPageComponent = {
    selector: 'requisitionsPage',
    component: {
        bindings: {
            $transition$: '<'
        },
        // templateUrl: 'app/partials/missioncontrol/requisitions/requisitions-page.html',
        template: TEMPLATE.default,
        controller: RequisitionsPageController
    }
};
//# sourceMappingURL=requisitions-page.component.js.map